import { render, staticRenderFns } from "./iconed-list.vue?vue&type=template&id=71ff59ce&scoped=true"
import script from "./iconed-list.vue?vue&type=script&lang=js"
export * from "./iconed-list.vue?vue&type=script&lang=js"
import style0 from "./iconed-list.vue?vue&type=style&index=0&id=71ff59ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff59ce",
  null
  
)

export default component.exports